
(() => { if (document.documentElement.lang.split('-')[0] !== 'pl') return; const css = document.createElement('style'); css.id = 'levya-pl-cart-initial-style-js'; css.textContent = 'html[lang^="pl"] #moonbundle-cart-drawer .moonbundle-cart-item,html[lang^="pl"] #moonbundle-cart-drawer .moonbundle-cart-drawer-content{background-color:#fff!important}'; document.head.append(css); })();
(() => {
  if (document.documentElement.lang.split('-')[0] !== 'pl') return;
  const labels = new Map([['Votre livraison est offerte', 'Koszt dostawy zobaczysz przy płatności'], ['Livraison offerte', 'Dostawa'], ['Retirer un lot', 'Zmniejsz liczbę zestawów'], ['Ajouter un lot identique', 'Dodaj taki sam zestaw'], ['Supprimer ce lot', 'Usuń zestaw'], ['Nazwa', 'Imię'], ['Numéro de commande', 'Numer zamówienia'], ['(facultatif)', '(opcjonalnie)'], ['Nous contacter', 'Kontakt'], ['Une question sur votre commande, une taille ou nos chaussettes ? L’équipe Levya est à votre écoute.', 'Masz pytanie o zamówienie, rozmiar lub nasze skarpety? Zespół Levya chętnie Ci pomoże.'], ['Écrivez-nous à l’aide du formulaire ci-dessous. Pour une demande concernant une commande, indiquez son numéro dans votre message et utilisez l’adresse e-mail renseignée lors de votre achat.', 'Napisz do nas za pomocą poniższego formularza. Jeśli pytanie dotyczy zamówienia, podaj jego numer i użyj adresu e-mail podanego podczas zakupu.'], ['Numéro de commande (facultatif)', 'Numer zamówienia (opcjonalnie)'], ['Mon panier', 'Twój koszyk'], ['Total :', 'Razem:'], ['Réductions', 'Rabaty'], ['Paiement sécurisé', 'Przejdź do płatności'], ['close the cart drawer', 'Zamknij koszyk']]);
  let queued = false;
  const translate = () => {
    queued = false;
    const drawer = location.pathname.endsWith('/pages/contact') ? document.body : document.querySelector('#moonbundle-cart-drawer');
    if (!drawer) return;
    const walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (['SCRIPT', 'STYLE'].includes(node.parentElement?.tagName)) continue;
      const source = node.nodeValue.trim();
      let target = labels.get(source.replace(/\s+/g, ' '));
      if (!target && source.startsWith('Vous économisez ')) target = source.replace('Vous économisez ', 'Oszczędzasz ');
      if (!target && source.startsWith('Save :')) target = source.replace('Save :', 'Oszczędzasz:');
      if (!target && source.startsWith('Paiement sécurisé ·')) target = source.replace('Paiement sécurisé', 'Przejdź do płatności');
      if (target && target !== source) node.nodeValue = node.nodeValue.replace(source, target);
    }
    drawer.querySelectorAll('[aria-label], [placeholder]').forEach(element => {
      const source = element.getAttribute('aria-label');
      if (labels.has(source)) element.setAttribute('aria-label', labels.get(source));
      const placeholder = element.getAttribute('placeholder'); if (labels.has(placeholder)) element.setAttribute('placeholder', labels.get(placeholder));
    });
  };
  const schedule = () => { if (!queued) { queued = true; setTimeout(translate, 150); } };
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  translate();
})();

// Match the grouped Polish cart thumbnail to the selected variant photo.
(() => {
  if (document.documentElement.lang.split('-')[0] !== 'pl') return;
  const updatePhotos = () => {
    document.querySelectorAll('.moonbundle-cart-drawer-items').forEach(list => {
      const source = Array.from(list.querySelectorAll('.moonbundle-cart-item img')).find(img => (img.currentSrc || img.src).includes('levya-photo-'));
      if (!source) return;
      list.querySelectorAll('.levya-cart-pack-image').forEach(img => {
        const url = source.currentSrc || source.src;
        if (img.getAttribute('src') !== url) { img.src = url; img.alt = source.alt || 'Skarpety uciskowe Levya'; }
      });
    });
  };
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; updatePhotos(); });
  }).observe(document.body, {childList:true,subtree:true});
  updatePhotos();
})();
